import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router, RoutesRecognized, ActivatedRoute } from '@angular/router';
import { Location, NgStyle } from '@angular/common';
import { Store } from '@ngrx/store';
import { filter, pairwise } from 'rxjs/operators';
import * as PlanNumActions from './store/actions/plannum.action';
import * as AddressActions from './store/actions/address.action';
import * as NameActions from './store/actions/name.action';
import * as NameActions2 from './store/actions/compoundname2.action';
import * as RoleActions from './store/actions/role.action';
import * as RoleActions2 from './store/actions/role2.action';
import * as DocTypeActions from './store/actions/doctype.action';
import * as BPActions from './store/actions/bookpage.action';
import * as DocNumActions from './store/actions/docnum.action';
import * as AmountActions from './store/actions/amountrange.action';
import { CoreSearchDataState as AppState, getRegSearchState } from './store';
import * as DateRangeActions from './store/actions/daterange.action';
import * as CityActions from './store/actions/citytown.action';
import * as BookPageActions from './store/actions/bookpage.action';
import { NavMenuService } from './shared/services/nav-menu-service';
import * as PlanRoleActions from './store/actions/planrole.action';
import * as CertTypeActions from './store/actions/plancerttype.action';
//import { OnPageVisible, OnPageHidden, OnPageVisibilityChange } from "ngx-page-visibility";
import { ShoppingBasketService } from './shared/services/shopping-basket.service'
import { DocBasketExComponent } from './shared/components/doc-basket-ex/doc-basket-ex.component'
import { Subject } from 'rxjs';
import { NgModel } from '@angular/forms';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  title = 'ClientApp';
  screenWidth: any;
  showLoader: any;
  @ViewChild(DocBasketExComponent, {static: false}) docBasketChild;
  //initialized: boolean = false;

  constructor(public nav: NavMenuService, private router: Router, private store: Store<AppState>, private location: Location, private route: ActivatedRoute, private sbService: ShoppingBasketService) {
    this.getScreenSize();
    var newNavMenuItem = {
      displayName: "Recorded Plans",
      name: "RecordedLandPlans",
      links: [
        {
          displayName: "Name",
          path: "rec-plan-name-search"
        },
        //{
        //  displayName: "Address",
        //  path: "rec-plan-address-search"
        //},
        {
          displayName: "Plan Book & Page",
          path: "rec-plan-bp-search"
        },
        //{
        //  displayName: "Plan No.",
        //  path: "rec-plan-plannum-search"
        //},

      ],
      isActive: false
    };
    var newNavMenuItem2 = {
      displayName: "View Restored Plans",
      name: "RestoredPlans",
      links: [
        {
          displayName: "Coming Soon",
          path: ""
        }
        //{
        //  displayName: "Owner",
        //  path: "reg-plan-owner-search"
        //},
        //{
        //  displayName: "Certificate",
        //  path: "reg-plan-certificate-search"
        //},
        //{
        //  displayName: "Court Case No.",
        //  path: "reg-plan-courtcasenum-search"
        //}

      ],
      isActive: false
    };
    var newNavMenuItem3 = {
      displayName: "Land Records 1840-1962",
      name: "Unindexed",
      links: [
        //{
        //  displayName: "Unindexed Property",
        //  //path: "/espropsearch"
        //},
        //{
        //  displayName: "1890-1940",
        //  path: "/fetch-data"
        //},
        //{
        //  displayName: "1941-1950",
        //  path: "/fetch-data"
        //}
        {
          displayName: "Unindexed Land Recs",
          path: "unindexed-doc-search"
        }//,
        //{
        //  displayName: "Writs 1911-1966",
        //  path: "unindexed-record-search2"
        //},
        // {
        //   displayName: "Attachments 1967-",
        //   path: "unindexed-record-search3"
        //},
        //{
        //  displayName: "Tax Maps",
        //  path: "unindexed-record-search4"
        //},
        // {
        //   displayName: "Day Books",
        //   path: "unindexed-record-search5"
        //},
        //{
        //  displayName: "Grantor/Grantee Indexes",
        //  path: "unindexed-record-search5"
        //}


      ],
      isActive: false
    };
    this.nav.pushNavMenuItem(newNavMenuItem3);
    this.nav.pushNavMenuItem(newNavMenuItem);
    this.nav.pushNavMenuItem(newNavMenuItem2);
/*    this.nav.pushNavMenuItem(newNavMenuItem2);*/
    //this.initialized = true;
    //alert(this.Location.path());
    if (this.location.path() == '/nhsearchcc') {
      //alert("navigate to root")
      this.router.navigate(['/']);
    } else {
      //alert(this.Location.path());
    }
    //console.log(this.Location.path());
  }

  ngOnInit(): void {

    var pth= window.location.href;
    var id = this.route.snapshot.paramMap.get('id');
    //this.route.params.subscribe(params => {
    //   id = params['id'];
    //   console.log("param = " + id);
    //   var id2 = id;
    //})

    console.log("param = " + id);
    var id2 = id;

    var i = 1;
    this.router.events.pipe(
      filter(e => e instanceof RoutesRecognized),
      pairwise()
    ).subscribe((event: any[]) => {
      console.log(event[0].urlAfterRedirects); // previous url
      console.log(event[1].urlAfterRedirects); //current url

      if (!event[0].urlAfterRedirects.endsWith('/rec-plan-name-result-pg') &&
        event[1].urlAfterRedirects.endsWith('/rec-plan-name-search')) {
        console.log("Calling delete from store");
        this.delRecFromStore(0);
      }

      if (!event[0].urlAfterRedirects.endsWith('/rec-plan-address-result-pg') &&
        event[1].urlAfterRedirects.endsWith('/rec-plan-address-search')) {
        console.log("Calling delete from store");
        this.delRecFromStore(0);
      }


      if (!event[0].urlAfterRedirects.endsWith('/rec-plan-plannum-doc-disp-pg') &&
        event[1].urlAfterRedirects.endsWith('/rec-plan-plannum-search')) {
        console.log("Calling delete from store");
        this.delRecFromStore(0);
      }

      if (!event[0].urlAfterRedirects.endsWith('/rec-plan-bp-doc-disp-pg') &&
        event[1].urlAfterRedirects.endsWith('/rec-plan-bp-search')) {
        console.log("Calling delete from store");
        this.delRecFromStore(0);
      }

      if (!event[0].urlAfterRedirects.includes('/unindexed-record-search') &&
        event[1].urlAfterRedirects.includes('/unindexed-record-search')) {
        console.log("Calling delete from store");
        this.delRecFromStore(0);
      }

      if ((!event[0].urlAfterRedirects.endsWith('/rec-name-result-pg') && !event[0].urlAfterRedirects.endsWith('/rec-alpha-result-pg')) &&
        event[1].urlAfterRedirects.endsWith('/rec-name-search')) {
        console.log("Calling delete from store");
              this.delRecFromStore(0);
      }

      if (!event[0].urlAfterRedirects.endsWith('/rec-address-result-pg') &&
        event[1].urlAfterRedirects.endsWith('/rec-address-search')) {
        console.log("Calling delete from store");
        this.delRecFromStore(0);
      }

      if (!event[0].urlAfterRedirects.endsWith('/rec-date-result-pg') &&
        event[1].urlAfterRedirects.endsWith('/rec-date-search')) {
        console.log("Calling delete from store");
        this.delRecFromStore(0);
      }

      if (!event[0].urlAfterRedirects.endsWith('/rec-value-result-pg') &&
        event[1].urlAfterRedirects.endsWith('/rec-value-search')) {
        console.log("Calling delete from store");
        this.delRecFromStore(0);
      }



      if (!event[0].urlAfterRedirects.startsWith('/rec-bp-doc-disp-pg') &&
        event[1].urlAfterRedirects.endsWith('/rec-bp-search')) {
        console.log("Calling delete from store");
        this.delRecFromStore(0);
      }

      if (!event[0].urlAfterRedirects.endsWith('/rec-docnum-doc-disp-pg') &&
        event[1].urlAfterRedirects.endsWith('/rec-doc-search')) {
        console.log("Calling delete from store");
        this.delRecFromStore(0);
      }

      if (!event[0].urlAfterRedirects.endsWith('/reg-name-result-pg') &&
        event[1].urlAfterRedirects.endsWith('/reg-name-search')) {
        console.log("Calling delete from store");
        this.delRecFromStore(0);
      }

      if (!event[0].urlAfterRedirects.endsWith('/reg-address-result-pg') &&
        event[1].urlAfterRedirects.endsWith('/reg-address-search')) {
        console.log("Calling delete from store");
        this.delRecFromStore(0);
      }

      if (!event[0].urlAfterRedirects.endsWith('/reg-date-result-pg') &&
        event[1].urlAfterRedirects.endsWith('/reg-date-search')) {
        console.log("Calling delete from store");
        this.delRecFromStore(0);
      }

      if (!event[0].urlAfterRedirects.endsWith('/reg-value-result-pg') &&
        event[1].urlAfterRedirects.endsWith('/reg-value-search')) {
        console.log("Calling delete from store");
        this.delRecFromStore(0);
      }


      if (!event[0].urlAfterRedirects.endsWith('/reg-owner-result-pg') &&
        event[1].urlAfterRedirects.endsWith('/reg-owner-search')) {
        console.log("Calling delete from store");
        this.delRecFromStore(0);
      }
      if (!event[0].urlAfterRedirects.endsWith('/reg-certificate-cert-disp-pg') &&
        event[1].urlAfterRedirects.endsWith('/reg-certificate-search')) {
        console.log("Calling delete from store");
        this.delRecFromStore(0);
      }

      if (!event[0].urlAfterRedirects.endsWith('/property-search-result-pg') &&
        event[1].urlAfterRedirects.endsWith('/rodcore')) {
        console.log("Calling delete from store");
        this.delRecFromStore(0);
      }

    });

      //if (!this.initialized) {
      //  this.initialized = true;
      //  this.router.navigate(['/']);
      //}
  }

  receiveLoader($event) {
    this.showLoader = $event;
    console.log("show - " + this.showLoader)
  }

  /**
  * Delete input parameters from store.
  * @param index
  */
  delRecFromStore(index) {

    this.store.dispatch(new NameActions.RemoveName(index));
    this.store.dispatch(new NameActions2.RemoveName2(index));
    this.store.dispatch(new AddressActions.RemoveAddress(index));
    this.store.dispatch(new RoleActions.RemoveRole(index));
    this.store.dispatch(new RoleActions2.RemoveRole2(index));
    this.store.dispatch(new PlanNumActions.RemovePlanNum(index));
    this.store.dispatch(new DateRangeActions.RemoveDate(index));
    this.store.dispatch(new CityActions.RemoveCity(index));
    this.store.dispatch(new BookPageActions.RemoveBP(index));
    this.store.dispatch(new PlanRoleActions.RemoveRole(index));
    this.store.dispatch(new CertTypeActions.RemoveCertType(index));
    this.store.dispatch(new DocTypeActions.RemoveDoct(index));
    this.store.dispatch(new BPActions.RemoveBP(index));
    this.store.dispatch(new DocNumActions.RemoveDocNum(index));
    this.store.dispatch(new AmountActions.RemoveAmount(index));
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.screenWidth = window.innerWidth;
  }

  @HostListener('document:visibilitychange', ['$event'])
  visibilitychange() {
    this.checkHiddenDocument();
  }

  checkHiddenDocument() {
    console.log('OnPageVisible');
    console.log('visible');
    this.sbService.forceRefresh();
    this.sbService.triggerRender();
    //let cnt = JSON.parse(localStorage.getItem("basket")).length;
    //this.sbService.updateBasketCount(cnt);
    //this.docBasketChild.checkHiddenDocument();
/*    location.reload();*/
  }


  //@OnPageVisible()
  //logWhenPageVisible(): void {
  //  console.log('OnPageVisible');
  //  console.log('visible');
  //  let cnt = JSON.parse(localStorage.getItem("basket")).length;
  //  this.sbService.updateBasketCount(cnt);
  //}

  //@OnPageVisibilityChange()
  //logWhenPageVisibilityChanges(): void {
  //  console.log('OnPageVisibleChanged');
  //  console.log('visible changed');
  //  let cnt = JSON.parse(localStorage.getItem("basket")).length;
  //  this.sbService.updateBasketCount(cnt);
  //}
}
